import { Form, Input, InputNumber, Button, Layout, Row, Col,Upload,notification, message,Modal, Checkbox, Select,ConfigProvider, Divider, Collapse, Card, Menu    } from 'antd';
import React, { Component, Fragment } from "react";
import cabezal from '../Cabezal.jpg'
import { UploadOutlined,CheckOutlined, HomeOutlined,FileTextOutlined, MinusCircleOutlined, EyeInvisibleOutlined, EyeTwoTone, LockOutlined,MailOutlined, UserOutlined, LogoutOutlined} from '@ant-design/icons';
import 'react-phone-input-2/lib/style.css'
import axios from "axios";
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import Navbar from '../components/NavBar' 

class App extends Component {
  constructor(props){
    super(props)
    this.state={
      phone: '',
      sended: false,
      showRegistrate: false,
      genres:[],
      fileList: [],
      authors:[],
    }
    // const promise = axios.get('https://back.premiocasa.cult.cu/api/casa/genero/')
    // const dataPromise = promise.then((response)=> response.data)
    // console.log(dataPromise)
  }

  async componentDidMount() {
    const response = await fetch('https://back.premiocasa.cult.cu/api/casa/genero/');
    const json = await response.json();
    if(json['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    this.setState({ genres: json });
  }

  addAuthor = () =>{

  }
  async logout(){
    await fetch('https://back.premiocasa.cult.cu/api/logout',{
      method: "post",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    }).then(result=>{
      if(result.status == 200){
        var userId = localStorage.getItem("UserId")
        const data_log= new FormData()
        data_log.append('usuario',userId)
        data_log.append('accion',"Salida del sistema")
      
        axios.post('https://back.premiocasa.cult.cu/api/casa/logs/', data_log)
        localStorage.clear()
        window.location.reload(); 
      }
      else{
        notification.error({
      message:'Error',
      description:'Hubo un error, por favor intente más tarde',
    })}
    })
  }

  render() {
    
    const layout = {
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },

    }
    const centerStyle = {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      marginLeft:'203px'
    };

    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          offset: 1,
        },
        sm: {
          span: 4,
          offset: 8,
        },
      },
    };
    
    const validateMessages = {
      required: '${label} es requerido!',
      types: {
        email: '${label} no es un email válido!',
        number: '${label} no es un número válido!',
      },
      number: {
        range: '${label} must be between ${min} and ${max}',
      },
    }

    function addAuthors(formdata, users, name) {
      for (var i = 0; i < users.length; i++) {
        addSingleAuthor(formdata, users[i], name + "[" + i + "]");
      }
  }
  
  function addSingleAuthor(formdata, user, name) {
      for (var key in user) {
          formdata.append(name + "." + key,  user[key]);
      }
  }
      
    const customRequest = (form) => {
     
      const data= new FormData()
      console.log(form)
      for(var aut in  form['autores']){
        form['autores'][aut]['tel'] = '+' + form['autores'][aut]['tel']
        console.log(form['autores'][aut]['tel'])

      }

    //   form
    //   console.log(form['pdf'].fileList[0])
      form['pdf'] =  form['pdf'].fileList[0]["originFileObj"]
      for ( var key in form ) {
        if(key =='autores'){
          data.append(key,JSON.stringify( form[key]));
          // addAuthors(data,form[key],'autores')
        }
        else{
          data.append(key, form[key]);
        }
    }

  //   for (var value of data.values()) {
  //     console.log(value);
  //  }
      axios.post('https://back.premiocasa.cult.cu/api/PremioCasa2022/obra/register/', data).then((res) => {
        if (res.status == 200){
          Modal.success({
            content: 'Gracias por registrarse en el concurso',
          });
        } ;
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise sus datos',
        });
      })
  }
    
    const checkBoxChange = e =>{
      console.log(e.target.checked)
      this.setState({showRegistrate:e.target.checked})
    }
    const handlesubmit = (values) =>{
      console.log(values)
        axios.post(
          'https://back.premiocasa.cult.cu/api/casa/obra/',{
          data:values
        }).then((res) => {
          console.log(res)
              if (res.status == 200) {
                notification.success("data successfully updated!");
              }
              else{
                notification.error({
                  message:'Error',
                  description:'Ter was an error',
                  
                });
              }
            })
            .catch((err) => {
              
              console.log(err)
            });
    }
      const onFinish = (values) => {
        console.log(values);
      }
      const { Header, Footer, Content } = Layout;
      const { Option } = Select;
      const { fileList } = this.state;
      const props = {
        onRemove: file => {
          this.setState(state => {
            const index = this.state.fileList.indexOf(file);
            const newFileList = state.fileList.slice();
            newFileList.splice(index, 1);
            return {
              fileList: newFileList,
            };
          });
        },
        beforeUpload: file => {
          this.setState({
            fileList: [file],
          });
          return false;
        },
        fileList,
      };
      const { Panel } = Collapse;
      const autores = <div>
        
          </div>
        const menu = (
          <Menu style={{height:'140'}} mode="inline">
                <Menu.Item key="home" icon={<HomeOutlined style={{ fontSize: '26px'}}/>} >
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/casa/jurado"> Mis obras</NavLink>
                </Menu.Item>
                <Menu.Item key="plays" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/casa/jurado_obras"> Obras en Concurso</NavLink>
                </Menu.Item>
                <Menu.Item key="plays_not" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
                  <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/casa/jurado_obras_preseleccionadas"> Obras Preseleccionadas</NavLink>
                </Menu.Item>
                <Menu.Item key="plays_final" icon={<FileTextOutlined style={{ fontSize: '26px'}} />}>
              <NavLink  style={{fontSize:'20px', fontWeight:'bold'}} to="/casa/jurado_obras_finalistas"> Obras Finalistas</NavLink>
            </Menu.Item>
          <Menu.Item key="logout" icon={<LogoutOutlined style={{ fontSize: '26px'}} />}  >
          <a onClick={this.logout}style={{fontSize:'20px', fontWeight:'bold'}}> Cerrar sesión </a>
          </Menu.Item>
          
          </Menu>
        )
    return (

      <div className="page-container">
        <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
<Layout style={{backgroundColor:'white'}}>
<Row>
            <Col><NavLink to="/casa/jurado"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
          </Row>
          <Row>
            <Col span={24}>
              <Navbar menu = {menu}/>
            
            </Col>
          </Row>
          <div style={{flexDirection:'column', flex:'1 0 auto', display:'flex'}} >
          
         
          <Row >
            <Col span={24} >
            <Content style={{ padding: '0 50px' }}>
          <Card title=" Bases Premio Literario Casa de las Américas " bordered={false}  >
         
         <p>La Casa de las Américas convoca para el año 2022 a la edición 62 de su Premio Literario. En esta ocasión podrán concursar obras inéditas en los géneros de <b> novela, poesía y ensayo de tema histórico-social. </b>
Los autores concursantes deberán regirse por las siguientes bases:

<ol style={{paddingLeft:'1.8em'}}>
  <li>Podrán concursar obras inéditas en español en los siguientes géneros: <b>novela, poesía y ensayo de tema histórico-social</b>. Se considerarán inéditas aun aquellas que hayan sido impresas en no más de la mitad.</li>
  <li>En <b>novela</b> y <b>poesía</b> solo podrán participar autores latinoamericanos, naturales o naturalizados. </li>
  <li>Por el premio de <b>ensayo de tema histórico-social</b> podrán concursar también autores de cualquier otra procedencia, con un libro sobre la América Latina o el Caribe, escrito en español. </li>
<li>Ningún autor podrá enviar más de un libro por género, ni participar con una obra en proceso de impresión, aunque esté inédita, o que haya obtenido algún premio nacional o internacional u opte por él mientras no se haya dado el fallo del Premio Casa de las Américas. Tampoco podrá participar en un género en el que hubiera obtenido ya este Premio, en alguno de los cuatro años anteriores.</li>
<li>Se otorgará un premio único e indivisible por cada género que consistirá en 3000 dólares o su equivalente en la moneda nacional que corresponda, y la publicación de la obra por la Casa de las Américas. Se otorgarán menciones si el jurado las estima necesarias, sin que ello implique retribución ni compromiso editorial por parte de la Casa de las Américas.</li>
<li>Las obras serán firmadas con seudónimo. </li>
<li>La Casa de las Américas se reserva el derecho de publicación de la que será considerada primera edición de las obras premiadas, hasta un máximo de 10 000 ejemplares, aunque se trate de una coedición o de reimpresiones coeditadas. Tal derecho incluye no solo evidentes aspectos económicos sino todas las características gráficas y otras de la mencionada primera edición. Asimismo, la Casa de las Américas, de común acuerdo con los autores, promoverá la circulación en formato digital de los libros premiados.</li>
<li>Los autores deberán enviar sus obras de manera digital, en pdf, accediendo a la plataforma<a  target="_blank" href="https://premiocasa.cu">https://premiocasa.cu</a>. Las obras no excederán en ningún caso de las quinientas (500) páginas.</li>
<li>El plazo de admisión cerrará el 31 de octubre de 2021 a las 12 de la noche, hora de La Habana. </li>
<li>  Los premios se darán a conocer 28 de enero de 2022.</li>
<li>El incumplimiento de alguna de estas bases conduciría a la invalidación del Premio otorgado.</li>
</ol> 
 

            </p>
            
         </Card>
          </Content>
              
              </Col>
          </Row>
   </div>
          
         


          </Layout>
        </ConfigProvider>
        </div>
        <div >
          <Footer style={{backgroundColor:'#00b2e7', position:'relative',bottom:'0px',left:'0px',right:'0px',flexShrink:0}}>
          <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#00b2e7',  marginBottom:'0px', bottom:'0px'}}>
          <Col xl={6} xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}>  <NavLink to="/casa/jury_bases" style={{color:'white'}}>Bases del concurso</NavLink></div></Col>
          <Col  xl={4}xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}><a style={{color:'white'}} href = "mailto: premiocasa@casa.cult.cu">premiocasa@casa.cult.cu</a></div></Col>
          <Col  xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} ><div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/"> Sitio Oficial Casa de las Américas</a> </div></Col>
          <Col xl={4}xs={24}sm={{span:6}} ><div style={{textAlign: 'center'}}><a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
          <Col  xl={4} xs={24} sm={{span:24}}><div style={{textAlign: 'center'}}> <NavLink to="/casa/jury_terminos" style={{color:'white'}}>Términos y condiciones de uso</NavLink></div></Col>
          
        </Row>
        </Footer>
        </div>
    </div>

    );
  }
}
export default App;


